import React from 'react'
import useDocumentUser from '../hooks/useDocumentUser.js'
import {UserContext} from '../context.js'

const UserProvider = ({children}) => {
  const user = useDocumentUser()
  return <UserContext.Provider value={user}>{children}</UserContext.Provider>
}

export default UserProvider
